var GiftOccasionView = (function (_app) {

    var _progressClassName = 'processing-animation';

    var GiftOccasionView = Backbone.View.extend({

        el: '@giftOccasion',

        events: {
            'click @giftOccasionToggle': '_save'
        },

        initialize: function () {
            _.bindAll(this, '_toggle', '_save', '_update');

            this.$giftOccasion = this.$('#GiftOccasion');

            this.$giftMessage = this.$('#GiftMessage');
            this.$giftMessageText = this.$('#GiftMessageText');

            this.$giftMessageEditForm = this.$('@giftMessageEdit');
            this.$giftMessageTextForm = this.$('@giftMessageText');

            this.$giftOccasionToggle = this.$('@giftOccasionToggle');

            this.$giftLabel = this.$('@giftLabel');

            this._toggle(true);

            InitTooltip(this.$('@info'), 'GiftInfoMessageField');

            _app.checkout.orderXhr.done(this._update);
            //_app.checkout.onUpdate(this._update);
        },

        _update: function (data, giftMessage, giftOccasion, giftDate) {
            if (data.GiftMessage) {
                var value = data.GiftMessage;
                this._setGiftMessage(value);
                this.$giftMessage.val(value);
                this._toggle(false);
            } else {
                this._toggle(true);
            }
        },

        _save: function () {
            if (this._editMode) {
                var giftMessage = this.$giftMessage.val();
                var giftOccasion = null;
                var giftDate = null;

                this._setGiftMessage(giftMessage);

                this.$el.addClass(_progressClassName);

                return api.setGiftParameters({
                    giftMessage: giftMessage,
                    giftOccasion: null,
                    giftStyle: null,
                    giftDate: null
                })
                .done(_.bind(function () {
                    this._toggle(false);
                }, this))
                .always(_.bind(function () {
                        this.$el.removeClass(_progressClassName);
                }, this));
            } else {
                this._toggle(true);
                return new $.Deferred().resolve().promise();
            }
        },

        _setGiftMessage: function(message) {
            this.$giftMessageText.html('"' + message.replace(/(?:\r\n|\r|\n)/g, '<br/>') + '"');
        },

        _toggle: function(editMode) {
            this.$giftMessageEditForm.toggleClass('hidden-block', !editMode);
            this.$giftMessageTextForm.toggleClass('hidden-block', editMode);
            this.$giftOccasionToggle.text(editMode ? 'Save' : 'Edit');
            this._editMode = editMode;
        }
    });

    var _giftOccasion = new GiftOccasionView();

    app.models.giftOccasions = {
        save: function() {
            return _giftOccasion._save();
        }
    }

});